















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GenericSearch from '../BookMeetingFlow/GenericSearch.vue';
@Component({
    components: {
        GenericSearch
    }
})
export default class CtaInputField extends Vue {
    public searchText: string = '';
    protected linkUrl!: string;
    protected linkTarget!: string;
    protected placeholder!: string;
    protected buttonText!: string;

    constructor() {
        super();

        this.linkUrl = this.$attrs['data-link-url'];
        this.linkTarget = this.$attrs['data-link-target'];
        this.placeholder = this.$attrs['data-placeholder'];
        this.buttonText = this.$attrs['data-button-text'];

        this.$attrs['data-link-url'] = '';
        this.$attrs['data-link-target'] = '';
        this.$attrs['data-placeholder'] = '';
        this.$attrs['data-button-text'] = '';
    }
    public updateSearchText(query: string) {
        this.searchText = query;
    }

    public clearSearch() {
        this.searchText = '';
    }

    public submitQueryText(query: string) {
        this.searchText = query;
        this.submitQuery();
    }
    private submitQuery() {
        window.open(this.linkUrl + this.searchText, this.linkTarget);
    }
}
